import { FC } from "react";
import DashbordStyles from "./Dashboard.module.scss";
import "./ShimmerDashboard.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { sliderSettings } from "../../../../common/utils";

interface ShimmerDashboardProps {
  isContracRedliningAllowed: boolean | undefined;
  isClauseCheckAllowed: boolean | undefined;
}

const ShimmerDashboard: FC<ShimmerDashboardProps> = ({
  isContracRedliningAllowed,
  isClauseCheckAllowed,
}) => {
  // Create an array of empty items to simulate the cards in the dashboard
  const cardCount = 4; // Adjust based on how many cards you typically display
  const shimmerCards = Array(cardCount).fill(null);

  const sliderSettingsObj = {
    ...sliderSettings(),
    className: DashbordStyles.carouselContainer,
  };

  return (
    <div className={`${DashbordStyles.dashboardContainer} shimmer-dashboard`}>
      <div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div className="shimmer-header-name"></div>
          <div className="shimmer-info-box"></div>
        </div>
        <div className="shimmer-subheader"></div>
      </div>

      <div className={DashbordStyles.mainContent}>
        {isContracRedliningAllowed && !isClauseCheckAllowed ? (
          <div
            className={`${DashbordStyles.contractRedliningCardsContainer} shimmer-cards-container`}
          >
            {shimmerCards.map((_, index) => (
              <div key={index} className={DashbordStyles.cardWrapper}>
                <div className="shimmer-card">
                  <div className="shimmer-card-header">
                    <div className="shimmer-icon"></div>
                    <div className="shimmer-title"></div>
                  </div>
                  <div className="shimmer-card-content">
                    <div className="shimmer-line"></div>
                    <div className="shimmer-line"></div>
                    <div className="shimmer-line shimmer-line-short"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <Slider {...sliderSettingsObj}>
            {shimmerCards.map((_, index) => (
              <div key={index} className={DashbordStyles.cardWrapper}>
                <div className="shimmer-card">
                  <div className="shimmer-card-header">
                    <div className="shimmer-icon"></div>
                    <div className="shimmer-title"></div>
                  </div>
                  <div className="shimmer-card-content">
                    <div className="shimmer-line"></div>
                    <div className="shimmer-line"></div>
                    <div className="shimmer-line shimmer-line-short"></div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        )}
      </div>

      <div className={`${DashbordStyles.rightContent}`}>
        <div className="shimmer-button"></div>
      </div>
    </div>
  );
};

export default ShimmerDashboard;
